import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PerformanceMonitorService {
  private frameCount = 0;
  private lastTime = performance.now();
  private fps = 60;
  private memoryUsage = 0;
  private isMonitoring = false;

  startMonitoring(): void {
    if (this.isMonitoring) return;
    this.isMonitoring = true;
    this.monitorPerformance();
  }

  stopMonitoring(): void {
    this.isMonitoring = false;
  }

  private monitorPerformance(): void {
    if (!this.isMonitoring) return;

    const now = performance.now();
    this.frameCount++;

    // Обновляем FPS каждую секунду
    if (now - this.lastTime >= 1000) {
      this.fps = Math.round((this.frameCount * 1000) / (now - this.lastTime));
      this.frameCount = 0;
      this.lastTime = now;

      // Проверяем использование памяти (если доступно)
      if ('memory' in performance) {
        const memory = (performance as any).memory;
        this.memoryUsage = Math.round(memory.usedJSHeapSize / 1024 / 1024);
      }

      // Логируем предупреждения о производительности
      if (this.fps < 30) {
        console.warn(`⚠️ Low FPS detected: ${this.fps} fps`);
      }

      if (this.memoryUsage > 100) {
        console.warn(`⚠️ High memory usage: ${this.memoryUsage} MB`);
      }

      // Выводим статистику каждые 30 секунд
      if (Math.floor(now / 30000) !== Math.floor(this.lastTime / 30000)) {
        console.log(`📊 Performance: ${this.fps} fps, ${this.memoryUsage} MB`);
      }
    }

    requestAnimationFrame(() => this.monitorPerformance());
  }

  getFPS(): number {
    return this.fps;
  }

  getMemoryUsage(): number {
    return this.memoryUsage;
  }

  // Принудительная сборка мусора (если доступна)
  forceGarbageCollection(): void {
    if ('gc' in window && typeof (window as any).gc === 'function') {
      (window as any).gc();
      console.log('🗑️ Forced garbage collection');
    }
  }
}